module.exports = __webpack_public_path__ + "img/candidate-rosa.988ba3cd.png";